export const getReceipts = (state) => state.receipts || {}
